export const elements = {
  cover: 'cover',
  title: 'title',
  self: 'self'
}
export const types = {
  three: 'case_detail_three',
  four: 'case_detail_four'
}
